import clsx from 'clsx';
import { GoPlus } from 'react-icons/go';

import styles from './SelectionChip.module.scss';

type SelectionChipVariant = 'default' | 'primary' | 'secondary';
type SelectionChipSize = 'sm' | 'md';

interface SelectionChipProps {
  label: string;
  onRemove?: () => void;
  variant?: SelectionChipVariant;
  size?: SelectionChipSize;
  className?: string;
}

const SelectionChip: React.FC<SelectionChipProps> = ({
  label,
  onRemove,
  variant = 'default',
  size = 'md',
  className,
}) => {
  const variantClass = {
    default: styles.variantDefault,
    primary: styles.variantPrimary,
    secondary: styles.variantSecondary,
  }[variant];

  const sizeClass = {
    sm: styles.sizeSm,
    md: styles.sizeMd,
  }[size];

  return (
    <div className={clsx(styles.chip, variantClass, sizeClass, className)}>
      <span className={styles.label}>{label}</span>
      {onRemove && (
        <button
          type="button"
          className={styles.removeButton}
          onClick={onRemove}
          aria-label={`Remove ${label}`}
        >
          <GoPlus className={styles.removeIcon} />
        </button>
      )}
    </div>
  );
};

export default SelectionChip;
